module.exports = __webpack_public_path__ + "img/FlutterWaveIcon.46bd0824.svg";